<script setup lang="ts">
import { useRoute } from 'vue-router';

import * as routeNames from '@/constants/routeNames';

import tabsStyles from '@/styles/tabs.module.scss';

const route = useRoute();
</script>

<template>
  <div :class="[tabsStyles.tabsWrapper]" class="w-min">
    <v-tabs :class="tabsStyles.tabs" :model-value="route.name">
      <v-tab
        :to="{ name: routeNames.PROFILE }"
        :value="routeNames.PROFILE"
        :ripple="false"
        :class="tabsStyles.tab"
        variant="plain"
      >
        Detailes
      </v-tab>
      <v-tab
        :to="{ name: routeNames.PROFILE_NOTIFICATIONS }"
        :value="routeNames.PROFILE_NOTIFICATIONS"
        :ripple="false"
        :class="tabsStyles.tab"
        variant="plain"
      >
        Notifications
      </v-tab>
      <v-tab
        :to="{ name: routeNames.PROFILE_SETTINGS }"
        :value="routeNames.PROFILE_SETTINGS"
        :ripple="false"
        :class="tabsStyles.tab"
        variant="plain"
      >
        Settings
      </v-tab>
    </v-tabs>
  </div>
</template>
